import * as React from 'react';
import * as moment from 'moment-timezone';


import './FeedItemContent.pcss';

interface Props {
	title:string;
	fromDate?:string;
	toDate?:string;
	children:any;
	feedItemContext:'feed'|'bundle-feed'|'full-post'|'chart'|'bundle-conversation'|'library'|'bundle-overview';
}

export const FeedItemContent = (props:Props) =>
<div className="feed-item-content">
	{'bundle-feed'===props.feedItemContext || 'bundle-conversation'===props.feedItemContext ?
		<h2 className="level2 shadow">{props.title}</h2> :
		<h3 className={`${'library'===props.feedItemContext?'level3':'level2'} shadow`}>{props.title}</h3>
	}
	<DateLine fromDate={props.fromDate} toDate={props.toDate} />
	<div className="body">{props.children}</div>
</div>
;

const DateLine = (props:{ fromDate?:string, toDate?:string }) => {
	if(props.fromDate && props.toDate){
		const fromDate = moment(props.fromDate);
		const toDate = moment(props.toDate);
		let dateLine = fromDate.tz(moment.tz.guess()).format('MMMM Do, h:mm a' );
		dateLine += ' – ' + ((fromDate.isAfter(toDate, 'day')) ? toDate.tz(moment.tz.guess()).format('MMMM Do, h:mm a' ) : toDate.tz(moment.tz.guess()).format('h:mm a'));
		return <div className="eventDateLine">{dateLine}</div>
	} else {
		return null;
	}
};


